// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MAb_","left":"styles_left__23mN3"};